import { Box, Checkbox, Divider, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ModalStyleFeedback } from "../../../common/components/ModalStyle";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import { useForm } from "react-hook-form";
import PrintIcon from "../clinicalcarechart/assets/PrintIcon";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import {
  getNursingCarePlan,
  getNursingCarePlanMasterData,
  saveNursingCarePlan,
} from "../../services/nursingCarePlanServices/NursingCarePlanServices";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { format } from "date-fns";

const planTypeOptions = [
  {
    id: 1,
    value: 1,
    label: "General",
  },
  {
    id: 2,
    value: 2,
    label: "ANC",
  },
  {
    id: 3,
    value: 3,
    label: "Post Operative",
  },
];
const NursingCarePlanModal = (props) => {
  const loggeduserInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { openNursingCarePlan, setOpenNursingCarePlan, patientInformation } =
    props;

  const defaultValues = { date: new Date(), planType: null };
  const { control, register, watch, setValue } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
  });

  let getDate = watch("date");
  let getPlanType = watch("planType");

  const [selectedShift, setSelectedShift] = useState("");
  const [openPainAssPrint, setOpenPainAssPrint] = useState(false);
  const [nursingCarePlanTableData, setNursingCarePlanTableData] = useState([]);
  const [openPost, setOpenPost] = useState(false);
  const [finalData, setFinalData] = useState(null);
  const [editDataId, setEditDataId] = useState(null);

  const renderPrint = (component) => {
    setTimeout(() => {
      setOpenPainAssPrint(false);
    }, 500);

    return (
      <div className="hidden">
        {/* <NursingPrint
          openPainAssPrint={openPainAssPrint}
          patientInformation={props.patientInformation}
          date={date}
        /> */}
      </div>
    );
  };

  const nursingCarePlanData = (planTypeId) => {
    getNursingCarePlanMasterData(planTypeId).then((response) => {
      setNursingCarePlanTableData(
        JSON.parse(response?.data?.result[0]?.diagnosis),
      );
    });
  };

  const getNursingCarePlanList = (shift, date) => {
    console.log("selectedShift7474", selectedShift);

    if (
      patientInformation !== undefined &&
      date !== undefined &&
      shift !== null
    ) {
      let obj = {
        admissionId: patientInformation?.AdmissionId,
        shift: shift,
        date: format(date, "yyyy-MM-dd"),
        carePlanType: getPlanType ? getPlanType?.id : null,
      };
      getNursingCarePlan(obj).then((response) => {
        setEditDataId(response.data.result?.id);
        if (
          response.data.result?.diagnosis !== null &&
          response.data.result?.diagnosis !== ""
        ) {
          setNursingCarePlanTableData(
            JSON.parse(response.data.result?.diagnosis),
          );
        } else {
          nursingCarePlanData(getPlanType?.id);
        }
      });
    }
  };

  const onSubmitNursingCarePlan = () => {
    let obj = {
      id: editDataId !== null && editDataId !== undefined ? editDataId : null,
      employeeId: loggeduserInfo?.empId,
      admissionId: patientInformation?.AdmissionId,
      shift: selectedShift,
      nursingPlanDiagnosisList: nursingCarePlanTableData
        ?.filter((obj) => obj?.id || obj?.checked === true)
        ?.map((header) => ({
          id: header?.id ? header?.id : null,
          diagnosisId: header?.diagnosisId,
          diagnosis: header?.diagnosis,
          relatedFactors: header?.relatedFactors
            ?.filter((val) => val?.id || val?.checked === true)
            ?.map((val) => ({
              id: val?.id ? val?.id : null,
              factorId: val?.factorId,
              description: val?.description,
              isDelete: val?.id && val?.checked === false ? true : false,
            })),
          goals: header?.goals
            ?.filter((val) => val?.id || val?.checked === true)
            ?.map((val) => ({
              id: val?.id ? val?.id : null,
              goalId: val?.goalId,
              description: val?.description,
              isDelete: val?.id && val?.checked === false ? true : false,
            })),
          interventions: header?.interventions
            ?.filter((val) => val?.id || val?.checked === true)
            ?.map((val) => ({
              id: val?.id ? val?.id : null,
              interventionId: val?.interventionId,
              description: val?.description,
              isDelete: val?.id && val?.checked === false ? true : false,
            })),
          result: header?.evaluation,
          isDelete: header?.id && header?.checked === false ? true : false,
        })),
    };
    if (selectedShift !== "") {
      setOpenPost(true);
      setFinalData(obj);
    } else {
      warningAlert("Please select shift...!");
    }
  };

  const postNursingCarePlan = () => {
    saveNursingCarePlan(finalData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          successAlert(response.data.message);
          setOpenPost(false);
          setOpenNursingCarePlan(false);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
      });
  };

  useEffect(() => {
    nursingCarePlanData(planTypeOptions[0]?.id);
    setValue("planType", planTypeOptions[0]);
  }, []);

  console.log("nursingCarePlanTableData", nursingCarePlanTableData);
  console.log("finalData", finalData);

  return (
    <>
      <Modal open={openNursingCarePlan}>
        <Box sx={ModalStyleFeedback} className="w-[95%] max-h-[90%] space-y-2">
          <div className="flex justify-between">
            <div className="flex space-x-2 items-center">
              <label className="font-semibold">Nursing Care Plan</label>
              <div className="w-40">
                <DatePickerField
                  control={control}
                  name="date"
                  label="Date"
                  inputFormat="dd-MM-yyyy"
                  inputRef={{
                    ...register("date", {
                      onChange: (e) => {
                        getNursingCarePlanList(selectedShift, e?.target?.value);
                      },
                    }),
                  }}
                />
              </div>
              <div className="w-40">
                <DropdownField
                  control={control}
                  name="planType"
                  placeholder="Plan Type"
                  dataArray={planTypeOptions}
                  isClearable={true}
                  inputRef={{
                    ...register("planType", {
                      onChange: (e) => {
                        if (e?.target?.value !== null) {
                          nursingCarePlanData(e?.target?.value?.id);
                        }
                      },
                    }),
                  }}
                />
              </div>
              {["M", "E", "N"]?.map((shift) => (
                <button
                  disabled={selectedShift === shift}
                  type="button"
                  className={`${shift === selectedShift ? "bg-customBlue text-white" : "text-customBlue bg-white"} border border-customBlue rounded-full w-7 h-7 flex justify-center items-center`}
                  onClick={() => {
                    setSelectedShift(shift);
                    getNursingCarePlanList(shift, getDate);
                  }}
                >
                  {shift}
                </button>
              ))}
              <button
                type="button"
                onClick={() => {
                  setOpenPainAssPrint(true);
                }}
              >
                <PrintIcon />
              </button>
            </div>
            <div className="flex space-x-2 items-center">
              <div className="flex border border-black rounded py-1">
                <div className="font-semibold border-r border-black px-2">
                  M-Met
                </div>
                <div className="font-semibold border-r border-black px-2">
                  P-Partially
                </div>
                <div className="font-semibold px-2">Un-Unmet</div>
              </div>
              <button
                type="button"
                onClick={() => {
                  setOpenNursingCarePlan(false);
                  setSelectedShift("");
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_13757_21637)">
                    <path
                      d="M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
                      fill="#D21919"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_13757_21637">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
          <div className="bg-[#F1F1F1] rounded p-2 grid grid-cols-3 text-sm">
            <div className="flex items-center">
              <label className="font-semibold w-24">Patient Name</label>
              <label className="">
                &nbsp;:&nbsp;
                {patientInformation?.patientName ||
                  patientInformation?.["Patient Name"]}
              </label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold w-32">MR No.</label>
              <label className="">
                &nbsp;:&nbsp;
                {patientInformation?.MRNo}
              </label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold">Age</label>
              <label className="">
                &nbsp;:&nbsp;
                {patientInformation?.AgeYear}
              </label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold w-24">Bed No.</label>
              <label className="">
                &nbsp;:&nbsp;
                {patientInformation?.["Bed No"]}
              </label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold w-32">Arrival Date & Time</label>
              <label className="">
                &nbsp;:&nbsp;
                {patientInformation?.arrivalDateTime}
              </label>
            </div>
          </div>
          <div className="w-full bg-slate-200">
            <div className="flex w-full text-center py-2">
              <div className="font-semibold w-[5%]">M</div>
              <div className="font-semibold w-[25%]">Related To Factors</div>
              <div className="font-semibold w-[25%]">
                Expected Outcomes (Goals)
              </div>
              <div className="font-semibold w-[25%]">Intervention</div>
              <div className="font-semibold w-[20%]">Evaluation</div>
            </div>
          </div>
          <div className="space-y-1">
            {nursingCarePlanTableData?.map((headerRow, headerIndex) => (
              <div className="border rounded p-2">
                <fieldset
                  className="flex items-center w-full"
                  onChange={(e) => {
                    setNursingCarePlanTableData((prevData) =>
                      prevData?.map((val, valIndex) =>
                        valIndex === headerIndex
                          ? {
                              ...val,
                              checked: e?.target?.checked,
                              relatedFactors:
                                e?.target?.checked === false
                                  ? val?.relatedFactors?.map((val) => ({
                                      ...val,
                                      checked: false,
                                    }))
                                  : val?.relatedFactors,
                              goals:
                                e?.target?.checked === false
                                  ? val?.goals?.map((val) => ({
                                      ...val,
                                      checked: false,
                                    }))
                                  : val?.goals,
                              interventions:
                                e?.target?.checked === false
                                  ? val?.interventions?.map((val) => ({
                                      ...val,
                                      checked: false,
                                    }))
                                  : val?.interventions,
                              evaluation:
                                e?.target?.checked === false
                                  ? ""
                                  : val?.evaluation,
                            }
                          : { ...val },
                      ),
                    );
                  }}
                >
                  <Checkbox checked={headerRow?.checked} size="small" />
                  <label
                  // onClick={() => {
                  //   setNursingCarePlanTableData((prevData) =>
                  //     prevData?.map((val, valIndex) =>
                  //       valIndex === headerIndex
                  //         ? {
                  //             ...val,
                  //             checked: val?.checked === true ? false : true,
                  //           }
                  //         : { ...val },
                  //     ),
                  //   );
                  // }}
                  // className="cursor-pointer"
                  >
                    {headerRow?.diagnosis}
                  </label>
                </fieldset>
                {headerRow?.checked === true && (
                  <table className="w-full border-collapse border table-fixed">
                    <tr className="flex w-full">
                      <td className="w-[5%] border">
                        <div className="flex items-center justify-center h-full">
                          <div className="flex flex-col justify-between h-full py-5">
                            {["I", "II", "III"]?.map((inflamattory) => (
                              <button
                                type="button"
                                className={`${headerRow?.inflamattory === inflamattory ? "bg-customBlue text-white" : "text-customBlue bg-white"} flex items-center justify-center border rounded border-customBlue w-8 h-5`}
                              >
                                {inflamattory}
                              </button>
                            ))}
                          </div>
                        </div>
                      </td>
                      <td className="w-[25%] border">
                        <table className="w-full border-collapse border">
                          <tbody>
                            {headerRow?.relatedFactors?.map(
                              (factor, factorIndex) => (
                                <tr key={factorIndex}>
                                  <td
                                    className={`border p-1 ${factor?.checked === true ? "bg-blue-200" : ""}`}
                                    onClick={() => {
                                      setNursingCarePlanTableData((prevData) =>
                                        prevData?.map((val, valIndex) =>
                                          valIndex === headerIndex
                                            ? {
                                                ...val,
                                                relatedFactors:
                                                  val?.relatedFactors?.map(
                                                    (obj, objIndex) =>
                                                      objIndex === factorIndex
                                                        ? {
                                                            ...obj,
                                                            checked:
                                                              obj?.checked ===
                                                              true
                                                                ? false
                                                                : true,
                                                          }
                                                        : { ...obj },
                                                  ),
                                              }
                                            : { ...val },
                                        ),
                                      );
                                    }}
                                  >
                                    {factor?.description}
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      </td>
                      <td className="w-[25%] border">
                        <table className="w-full border-collapse border">
                          <tbody>
                            {headerRow?.goals?.map((goal, goalIndex) => (
                              <tr key={goalIndex}>
                                <td
                                  className={`border p-1 ${goal?.checked === true ? "bg-blue-200" : ""}`}
                                  onClick={() => {
                                    setNursingCarePlanTableData((prevData) =>
                                      prevData?.map((val, valIndex) =>
                                        valIndex === headerIndex
                                          ? {
                                              ...val,
                                              goals: val?.goals?.map(
                                                (obj, objIndex) =>
                                                  objIndex === goalIndex
                                                    ? {
                                                        ...obj,
                                                        checked:
                                                          obj?.checked === true
                                                            ? false
                                                            : true,
                                                      }
                                                    : { ...obj },
                                              ),
                                            }
                                          : { ...val },
                                      ),
                                    );
                                  }}
                                >
                                  {goal?.description}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </td>
                      <td className="w-[25%] border">
                        <table className="w-full">
                          <tbody>
                            {headerRow?.interventions?.map(
                              (intervention, interventionIndex) => (
                                <tr key={interventionIndex}>
                                  <td
                                    className={`border p-1 ${intervention?.checked === true ? "bg-blue-200" : ""}`}
                                    onClick={() => {
                                      setNursingCarePlanTableData((prevData) =>
                                        prevData?.map((val, valIndex) =>
                                          valIndex === headerIndex
                                            ? {
                                                ...val,
                                                interventions:
                                                  val?.interventions?.map(
                                                    (obj, objIndex) =>
                                                      objIndex ===
                                                      interventionIndex
                                                        ? {
                                                            ...obj,
                                                            checked:
                                                              obj?.checked ===
                                                              true
                                                                ? false
                                                                : true,
                                                          }
                                                        : { ...obj },
                                                  ),
                                              }
                                            : { ...val },
                                        ),
                                      );
                                    }}
                                  >
                                    {intervention?.description}
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      </td>
                      <td className="w-[20%]">
                        <div className="flex items-center justify-center h-full">
                          <div className="space-y-1 text-center">
                            <label className="text-sm font-semibold">
                              {selectedShift === "M"
                                ? "Morning"
                                : selectedShift === "E"
                                  ? "Evening"
                                  : selectedShift === "N"
                                    ? "Night"
                                    : ""}
                            </label>
                            <div className="flex space-x-1 items-center">
                              {["M", "P", "Un"]?.map((evaluation) => (
                                <button
                                  type="button"
                                  className={`${headerRow?.evaluation === evaluation ? "bg-customBlue text-white" : "text-customBlue bg-white"} border border-customBlue rounded-full w-7 h-7 flex justify-center items-center`}
                                  onClick={() => {
                                    setNursingCarePlanTableData((prevData) =>
                                      prevData?.map((val, valIndex) =>
                                        valIndex === headerIndex
                                          ? {
                                              ...val,
                                              evaluation: evaluation,
                                            }
                                          : { ...val },
                                      ),
                                    );
                                  }}
                                >
                                  {evaluation}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                )}
              </div>
            ))}
          </div>
          {nursingCarePlanTableData?.length > 0 && (
            <div className="flex justify-end">
              <CommonButton
                type="button"
                label={`${!editDataId ? "Save" : "Update"}`}
                className="bg-customGreen text-white"
                onClick={() => {
                  onSubmitNursingCarePlan();
                }}
              />
            </div>
          )}
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={() => {
          setOpenPost(false);
        }}
        confirmationSubmitFunc={postNursingCarePlan}
        confirmationLabel="Confirmation"
        confirmationMsg={`Are you sure want to ${!editDataId ? "save" : "update"} this record ?`}
        confirmationButtonMsg={`${!editDataId ? "Save" : "Update"}`}
      />
      {openPainAssPrint && renderPrint()}
    </>
  );
};

export default NursingCarePlanModal;
